export default {
  data () {
    return {
      // 活动类型
      activityTypeMenu:{
        7: '天天特价',
        8: '送水',
        9: '限时秒杀',
        10: '精准营销',
        11: '抽奖宝'
      },
      // 申请状态
      activityStatusMenu:{
        0: '审核中',
        1: '审核未通过',
        2: '审核通过',
        3: '待生效',
        4: '生效中',
        5: '已结束',
        6: '未审核',
        7: '审核撤回',
        8: '审核驳回'
      },
      // 配置状态
      configStateMenu:{
        0: '未配置',
        1: '配置成功',
        2: '配置失败'
      },
      // 运行状态
      runStateMenu:{
        0: '未上架',
        1: '已上架',
        2: '已下架'
      },
      // 商家返券
      isRebateMenu:{
        0: '否',
        1: '是'
      },
      // isFundUsed
      isFundUsedMenu:{
        0: '否',
        1: '是'
      }
    }
  }
}